<span>{{curLabel}}</span>
